import React, { useEffect, useState } from 'react';
import axios from 'axios';

function Invoices() {
    const [invoices, setInvoices] = useState([]);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const [formData, setFormData] = useState({
        invoice_number: '',
        reference_number: '',
        document_type: 'M',
        service_type_code: '',
        service_type_label: '',
        property_type_code: '',
        property_type_label: '',
        year_short: '',
        object_number: '',
        try_number: '',
        customer_name: '',
        object_id: 0,
        amount_net: '',
        vat_rate: '',
        amount_gross: '',
        status: '',
        issue_date: '',
        due_date: '',
        paid: false
    });

    const loadInvoices = async () => {
        try {
            const response = await axios.get('/api/invoices');
            setInvoices(Array.isArray(response.data) ? response.data : []);
        } catch (err) {
            setInvoices([]);
            setError('Rechnungen konnten nicht geladen werden.');
        }
    };

    useEffect(() => {
        loadInvoices();
    }, []);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleNumberPreview = async () => {
        setMessage('');
        setError('');

        try {
            const response = await axios.get('/api/invoice-number-preview', {
                params: {
                    document_type: formData.document_type || 'M',
                    service_type_code: formData.service_type_code || 'P',
                    property_type_code: formData.property_type_code || '1',
                    object_number: formData.object_number || '1'
                }
            });

            setFormData((prev) => ({
                ...prev,
                invoice_number: response.data.invoice_number || ''
            }));
            setMessage('Rechnungsnummer erfolgreich vorgeschlagen.');
        } catch (err) {
            setError('Nummernvorschau für Rechnung fehlgeschlagen.');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');

        try {
            const response = await axios.post('/api/invoices', {
                ...formData,
                object_number: Number(formData.object_number),
                try_number: Number(formData.try_number),
                object_id: Number(formData.object_id),
                amount_net: Number(formData.amount_net),
                vat_rate: Number(formData.vat_rate),
                amount_gross: Number(formData.amount_gross)
            });

            if (response.status === 200 || response.status === 201) {
                setMessage('Rechnung erfolgreich erstellt.');
                await loadInvoices();
            }
        } catch (err) {
            setError('Rechnung konnte nicht gespeichert werden.');
        }
    };

    return (
        <div>
            <h1>Rechnungen</h1>

            {message && <p>{message}</p>}
            {error && <p className="error">{error}</p>}

            <button type="button" onClick={handleNumberPreview}>
                Nummernvorschau
            </button>

            <form onSubmit={handleSubmit}>
                <input
                    type="text"
                    name="invoice_number"
                    placeholder="Rechnungsnummer"
                    value={formData.invoice_number}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="reference_number"
                    placeholder="Referenznummer"
                    value={formData.reference_number}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="document_type"
                    value={formData.document_type}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="service_type_code"
                    placeholder="Leistungsart-Code"
                    value={formData.service_type_code}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="service_type_label"
                    placeholder="Leistungsart"
                    value={formData.service_type_label}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="property_type_code"
                    placeholder="Objektart-Code"
                    value={formData.property_type_code}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="property_type_label"
                    placeholder="Objektart"
                    value={formData.property_type_label}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="year_short"
                    placeholder="Jahr"
                    value={formData.year_short}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="object_number"
                    placeholder="Objektnummer"
                    value={formData.object_number}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="try_number"
                    placeholder="Versuch"
                    value={formData.try_number}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="customer_name"
                    placeholder="Kundenname"
                    value={formData.customer_name}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="object_id"
                    placeholder="Objekt-ID"
                    value={formData.object_id}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="amount_net"
                    placeholder="Betrag netto"
                    value={formData.amount_net}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="vat_rate"
                    placeholder="USt-Satz"
                    value={formData.vat_rate}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="amount_gross"
                    placeholder="Betrag brutto"
                    value={formData.amount_gross}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="status"
                    placeholder="Status"
                    value={formData.status}
                    onChange={handleChange}
                    required
                />

                <input
                    type="date"
                    name="issue_date"
                    value={formData.issue_date}
                    onChange={handleChange}
                    required
                />

                <input
                    type="date"
                    name="due_date"
                    value={formData.due_date}
                    onChange={handleChange}
                    required
                />

                <label>
                    <input
                        type="checkbox"
                        name="paid"
                        checked={formData.paid}
                        onChange={handleChange}
                    />
                    Bezahlt
                </label>

                <button type="submit">Rechnung hinzufügen</button>
            </form>

            <table>
                <thead>
                    <tr>
                        <th>Rechnungsnummer</th>
                        <th>Kundenname</th>
                        <th>Betrag netto</th>
                        <th>Status</th>
                        <th>Bezahlt</th>
                    </tr>
                </thead>
                <tbody>
                    {invoices.map((invoice) => (
                        <tr key={invoice.id || invoice.invoice_number}>
                            <td>{invoice.invoice_number}</td>
                            <td>{invoice.customer_name}</td>
                            <td>{invoice.amount_net}</td>
                            <td>{invoice.status}</td>
                            <td>{invoice.paid ? 'Ja' : 'Nein'}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default Invoices;
